// src/utils/whatsapp.js — WhatsApp messages through the campaign API.
// The API key is NOT stored in the code. Put it in a file named .env.local in the project folder:
//   REACT_APP_WA_API_KEY=your-key-here
// then restart `npm start` (or run `npm run build` again before deploying).
const WA_API_KEY  = process.env.REACT_APP_WA_API_KEY || '';
const WA_ENDPOINT = process.env.REACT_APP_WA_ENDPOINT || 'https://backend.api-wa.co/campaign/combirds/api/v2';

function formatPhone(phone) {
  if (!phone) return null;
  let digits = phone.toString().replace(/\D/g, '');
  if (digits.length === 10) digits = '91' + digits;
  return '+' + digits;
}

// Always returns { ok, status, error?, data? } so the screen can tell the user what really happened
async function sendWhatsAppMessage({ campaignName, phone, userName, params }) {
  const destination = formatPhone(phone);
  if (!destination) return { ok: false, status: 0, error: 'No customer phone number.' };
  if (!WA_API_KEY) {
    return { ok: false, status: 0, error: 'WhatsApp API key is not set. Add REACT_APP_WA_API_KEY to .env.local and restart.' };
  }
  try {
    const res = await fetch(WA_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        apiKey: WA_API_KEY,
        campaignName,
        destination,
        userName: userName || 'Customer',
        source: 'PizzaBill',
        templateParams: params,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      console.warn('WhatsApp send failed:', res.status, data);
      const msg = res.status === 401
        ? 'WhatsApp provider rejected the API key (401). Create a new key in the provider dashboard and update REACT_APP_WA_API_KEY.'
        : `WhatsApp send failed (${res.status}). ${data?.message || data?.error || ''}`.trim();
      return { ok: false, status: res.status, error: msg, data };
    }
    return { ok: true, status: res.status, data };
  } catch (err) {
    console.warn('WhatsApp send error:', err);
    return { ok: false, status: 0, error: 'Could not reach the WhatsApp service: ' + err.message };
  }
}

export async function sendBillWhatsApp({
  phone, name, billNo, dateTime, tableOrOrder,
  itemsText, subtotal, gst, total, paymentMode,
  pointsEarned, totalPoints,
}) {
  return sendWhatsAppMessage({
    campaignName: 'vip_pizza_bill',
    phone,
    userName: name,
    params: [
      name || 'Customer',
      billNo,
      dateTime,
      tableOrOrder,
      itemsText,
      String(subtotal),
      String(gst),
      String(total),
      paymentMode,
      String(pointsEarned || 0),
      String(totalPoints || 0),
    ],
  });
}

export async function sendOrderReadyWhatsApp({
  phone, name, billNo, tableInfo, itemsText, total, message,
}) {
  return sendWhatsAppMessage({
    campaignName: 'vip_pizza_order_ready_billing',
    phone,
    userName: name,
    params: [
      name || 'Customer',
      billNo,
      tableInfo,
      itemsText,
      String(total),
      message,
    ],
  });
}